import whatsapp from "../../assets/images/whatsapp.png";
import React, { useState, useEffect } from "react";
import axios from "axios";

const Contact = () => {
  const [contact, setContact] = useState([]);

  useEffect(() => {
    getContact();
  }, []);

  const getContact = async (e) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}contact`
      );
      setContact(response.data.contacts);
      // console.log(response);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <section className="pt-24  pb-2 md:pt-24 md:mt-16" id="contact">
      <div
        className="container mx-auto px-6"
        data-aos="fade-up"
        data-aos-duration="800"
      >
        <div className="font-poppins  flex justify-center md:justify-normal  flex-col md:flex-row items-center  p-4 md:p-8 contact-box">
          <div className="border-l-[6px] border-secondary  pl-4 md:mr-8">
            <h3 className="text-slate-800 italic text-3xl md:text-3xl font-bold">
              Hubungi kami
            </h3>
            <p className="text-sm md:text-lg text-slate-500 mt-2 font-light">
              Tim Sales Consultant Kami akan segera membantu anda
            </p>
          </div>
          {contact.map((cnt, i) => (
            <div
              key={cnt.id}
              className="mt-4 w-full md:w-auto bg-[#2db742] transition duration-200 hover:bg-[#0f8120] rounded flex items-center py-3 px-4"
            >
              <a href={cnt.noHP} className="w-full flex" target="_blank">
                <div>
                  <img src={whatsapp} alt="" className="w-8 h-8" />
                </div>
                <div className="mt-0 poppins ml-4">
                  <p className="text-sm text-slate-100 font-light md:text-lg">
                    {cnt.name} - Owner
                  </p>
                  <p className="text-sm text-slate-50 font-bold md:text-lg">
                    Hubungi Kami di WhatsApp
                  </p>
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Contact;
